<script setup lang="ts">

// Приймаємо пропси
const props = defineProps<{
  modelValue: boolean; // Для v-model
}>()

// Емітуємо події
const emit = defineEmits(['update:modelValue'])

// Локальна обчислювана властивість для v-model
const snackbar = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

// Оновлення сторінки зі спробою зберегти стан
const reload = () => {
  reloadNuxtApp({persistState: true})
}
</script>

<template>
  <v-snackbar v-model="snackbar" color="primary" timeout="-1">
    <b>Оновлення застосунку!</b><br />
    Будь ласка, перезавантажте сторінку, щоб отримати останні зміни. Це не завадить вашій роботі.
    <template v-slot:actions="{ attrs }">
      <v-btn @click="reload">Оновити</v-btn>
    </template>
  </v-snackbar>
</template>
